<template>
  <div class="gp-content">
    <content-nav-bar class="secondary">
      <p class="level-item">Group Analytics By:</p>
      <div class="block level-item">
        <b-radio
          v-for="filter in filterTypes"
          :key="filter.label"
          v-model="filterType"
          :native-value="filter">
          {{ filter.label }}
        </b-radio>
      </div>
    </content-nav-bar>
    <div class="scroll-vertical dashboard-container">
      <tiles v-for="(row,i) in rows" :key="i">
        <div v-for="obj in row" :key="obj.label" class="tile is-parent is-4">
          <tile-basic
            class="is-info"
            :title="obj.label"
            :img="tileIcon(obj.label)"
            :values="tileListValues(obj.analytics)"
            :link="tileLink(obj)">
          </tile-basic>
        </div>
      </tiles>
    </div>
  </div>
</template>

<script>
import _ from 'lodash';
import mixin from '@/mixins/analytics';
import ContentNavBar from '@/components/ContentNavBar.vue';
import TileBasic from '@/components/TileBasic.vue';
import Tiles from '@/components/Tiles.vue';

export default {
  name: 'AnalyticsTiles',
  mixins: [mixin],
  components: {
    ContentNavBar,
    Tiles,
    TileBasic,
  },
  props: {
    analytics: {
      type: Array,
      required: true,
    },
    type: {
      type: String,
      default: 'categories',
    },
  },
  created() {
    // For some reason filter type is not getting filled in in the data section
    this.filterType = _.find(this.filterTypes, { value: this.type });
  },
  watch: {
    type() {
      this.filterType = _.find(this.filterTypes, { value: this.type });
    },
    filterType() {
      this.$emit('update:type', this.filterType.value);
    },
  },
  data() {
    return {
      columns: 3,
      filterType: _.find(this.filterTypes, { value: this.type }),
    };
  },
  computed: {
    filterTypes() {
      return [
        {
          label: 'Categories',
          value: 'categories',
          filter: 'category',
          icon: 'category',
        },
        {
          label: 'Actions',
          value: 'actions',
          filter: 'action',
          icon: 'action',
        },
        {
          label: 'Tags',
          value: 'tags',
          filter: 'tag',
          icon: 'tag',
        },
      ];
    },
    tileSmallIcon() {
      if (this.filterType === 'categories') {
        return 'category';
      }
      return 'circle';
    },
    tiles() {
      // Get the unique labels for the specific internalViewType (categories, actions, tags)
      const labels = this.unique(this.filterType.value);
      // Create a new array that is { label, analytics: [] }
      return _.map(labels, label => ({
        label,
        // eslint-disable-next-line
        analytics: _.filter(this.analytics, analytic => analytic[this.filterType.value].includes(label)),
      }));
    },
    rows() {
      return _.chunk(this.tiles, this.columns);
    },
  },
  methods: {
    tileLink(obj) {
      return {
        name: 'analytics.index',
        query: {
          v: 'table',
          fi: `${this.filterType.filter}:${obj.label}`,
        },
      };
    },
    tileListValues(analytics) {
      return [
        {
          label: 'Analytic Count',
          value: analytics.length,
        },
        {
          label: 'Example Analytics',
          value: `${this.analyticNameList(analytics, 3).join(', ')}`,
        },
      ];
    },
    analyticNameList(analytics, count) {
      return _.map(analytics.slice(0, count), 'name');
    },
    tileIcon(label) {
      if (label === 'Insider Threat') {
        return 'insider';
      }
      if (label === 'Auto Start') {
        return 'autorun';
      }
      if (label === 'Known Malware') {
        return 'malware';
      }
      if (label === 'Emerging Threats') {
        return 'threat';
      }
      if (label === 'IR Readiness') {
        return 'ir';
      }
      if (label === 'Privacy') {
        return 'privacy';
      }
      return 'logic';
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/scss/colors.scss';

.vlevel {
  flex-shrink: 1; // This makes the text wrap

  p.vlevel-item {
    text-align: left;
  }
}

</style>
